/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-notice-width: The width of the component.
*/
:host([scale=s]) {
  --calcite-notice-spacing-token-small: 0.5rem;
  --calcite-notice-spacing-token-large: 0.75rem;
}
:host([scale=s]) .container slot[name=title]::slotted(*),
:host([scale=s]) .container *::slotted([slot=title]) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}
:host([scale=s]) .container slot[name=message]::slotted(*),
:host([scale=s]) .container *::slotted([slot=message]) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
}
:host([scale=s]) ::slotted(calcite-link) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
}
:host([scale=s]) .notice-close {
  padding: 0.5rem;
}

:host([scale=m]) {
  --calcite-notice-spacing-token-small: 0.75rem;
  --calcite-notice-spacing-token-large: 1rem;
}
:host([scale=m]) .container slot[name=title]::slotted(*),
:host([scale=m]) .container *::slotted([slot=title]) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}
:host([scale=m]) .container slot[name=message]::slotted(*),
:host([scale=m]) .container *::slotted([slot=message]) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}
:host([scale=m]) ::slotted(calcite-link) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}

:host([scale=l]) {
  --calcite-notice-spacing-token-small: 1rem;
  --calcite-notice-spacing-token-large: 1.25rem;
}
:host([scale=l]) .container slot[name=title]::slotted(*),
:host([scale=l]) .container *::slotted([slot=title]) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size-1);
  line-height: 1.375;
}
:host([scale=l]) .container slot[name=message]::slotted(*),
:host([scale=l]) .container *::slotted([slot=message]) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}
:host([scale=l]) ::slotted(calcite-link) {
  margin-block: 0.125rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}

:host([width=auto]) {
  --calcite-notice-width: auto;
}

:host([width=half]) {
  --calcite-notice-width: 50%;
}

:host([width=full]) {
  --calcite-notice-width: 100%;
}

:host {
  margin-inline: auto;
  display: none;
  max-inline-size: 100%;
  align-items: center;
  inline-size: var(--calcite-notice-width);
}

.container {
  pointer-events: none;
  margin-block: 0px;
  box-sizing: border-box;
  display: flex;
  inline-size: 100%;
  background-color: var(--calcite-color-foreground-1);
  opacity: 0;
  overflow: hidden;
  max-block-size: 0;
  transition-property: opacity, max-block-size;
  transition-duration: var(--calcite-animation-timing);
  text-align: start;
  border-inline-start: var(--calcite-border-width-md) solid;
  box-shadow: 0 0 0 0 transparent;
}

.notice-close {
  outline-color: transparent;
}
.notice-close:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host {
  display: flex;
}

:host([open]) .container {
  pointer-events: auto;
  max-block-size: 100%;
  align-items: center;
  opacity: 1;
  --tw-shadow: 0 4px 8px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 4px 8px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  overflow: visible;
}

.container slot[name=title]::slotted(*),
.container *::slotted([slot=title]) {
  margin: 0px;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
}

.container slot[name=message]::slotted(*),
.container *::slotted([slot=message]) {
  margin: 0px;
  display: inline;
  font-weight: var(--calcite-font-weight-normal);
  color: var(--calcite-color-text-2);
  margin-inline-end: var(--calcite-notice-spacing-token-small);
}

.notice-content {
  box-sizing: border-box;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  padding-inline: var(--calcite-notice-spacing-token-large);
  flex: 0 0 auto;
  display: flex;
  min-inline-size: 0px;
  flex-direction: column;
  overflow-wrap: break-word;
  flex: 1 1 0;
  padding-block: var(--calcite-notice-spacing-token-small);
  padding-inline: 0 var(--calcite-notice-spacing-token-small);
}
.notice-content:first-of-type:not(:only-child) {
  padding-inline-start: var(--calcite-notice-spacing-token-large);
}
.notice-content:only-of-type {
  padding-block: var(--calcite-notice-spacing-token-small);
  padding-inline: var(--calcite-notice-spacing-token-large);
}

.notice-icon {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  padding-block: var(--calcite-notice-spacing-token-small);
  padding-inline: var(--calcite-notice-spacing-token-large);
  flex: 0 0 auto;
}

.notice-close {
  display: flex;
  cursor: pointer;
  align-items: center;
  align-self: stretch;
  border-style: none;
  background-color: transparent;
  color: var(--calcite-color-text-3);
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-sizing: border-box;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  padding-block: var(--calcite-notice-spacing-token-small);
  padding-inline: var(--calcite-notice-spacing-token-large);
  flex: 0 0 auto;
  -webkit-appearance: none;
}
.notice-close:hover, .notice-close:focus {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-1);
}
.notice-close:active {
  background-color: var(--calcite-color-foreground-3);
}

.actions-end {
  display: flex;
  align-self: stretch;
}

:host([kind=brand]) .container {
  border-color: var(--calcite-color-brand);
}
:host([kind=brand]) .container .notice-icon {
  color: var(--calcite-color-brand);
}

:host([kind=info]) .container {
  border-color: var(--calcite-color-status-info);
}
:host([kind=info]) .container .notice-icon {
  color: var(--calcite-color-status-info);
}

:host([kind=danger]) .container {
  border-color: var(--calcite-color-status-danger);
}
:host([kind=danger]) .container .notice-icon {
  color: var(--calcite-color-status-danger);
}

:host([kind=success]) .container {
  border-color: var(--calcite-color-status-success);
}
:host([kind=success]) .container .notice-icon {
  color: var(--calcite-color-status-success);
}

:host([kind=warning]) .container {
  border-color: var(--calcite-color-status-warning);
}
:host([kind=warning]) .container .notice-icon {
  color: var(--calcite-color-status-warning);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}